export const OPEN_CRYPTA_AUDIO_GENRES_EDITOR =
    'OPEN_CRYPTA_AUDIO_GENRES_EDITOR';
export type OPEN_CRYPTA_AUDIO_GENRES_EDITOR = typeof OPEN_CRYPTA_AUDIO_GENRES_EDITOR;

export interface OpenCryptaAudioGenresEditor {
    type: OPEN_CRYPTA_AUDIO_GENRES_EDITOR;
    id: string;
    itemsId: string[];
}

export function openCryptaAudioGenresEditor(
    id: string,
    itemsId: string[]
): OpenCryptaAudioGenresEditor {
    return {
        type: OPEN_CRYPTA_AUDIO_GENRES_EDITOR,
        id,
        itemsId
    };
}

export const CLOSE_CRYPTA_AUDIO_GENRES_EDITOR =
    'CLOSE_CRYPTA_AUDIO_GENRES_EDITOR';
export type CLOSE_CRYPTA_AUDIO_GENRES_EDITOR = typeof CLOSE_CRYPTA_AUDIO_GENRES_EDITOR;

export interface CloseCryptaAudioGenresEditor {
    type: CLOSE_CRYPTA_AUDIO_GENRES_EDITOR;
    id: string;
    itemsId?: string[];
}

export function closeCryptaAudioGenresEditor(
    id: string,
    itemsId?: string[]
): CloseCryptaAudioGenresEditor {
    return {
        type: CLOSE_CRYPTA_AUDIO_GENRES_EDITOR,
        id,
        itemsId
    };
}

export const CHANGE_ITEM_CRYPTA_AUDIO_GENRES =
    'CHANGE_ITEM_CRYPTA_AUDIO_GENRES';
export type CHANGE_ITEM_CRYPTA_AUDIO_GENRES = typeof CHANGE_ITEM_CRYPTA_AUDIO_GENRES;

export interface ChangeItemCryptaAudioGenres {
    type: CHANGE_ITEM_CRYPTA_AUDIO_GENRES;
    id: string;
    itemId: string;
}

export function changeItemCryptaAudioGenres(
    id: string,
    itemId: string
): ChangeItemCryptaAudioGenres {
    return {
        type: CHANGE_ITEM_CRYPTA_AUDIO_GENRES,
        id,
        itemId
    };
}

export const SAVE_CRYPTA_AUDIO_GENRES = 'SAVE_CRYPTA_AUDIO_GENRES';
export type SAVE_CRYPTA_AUDIO_GENRES = typeof SAVE_CRYPTA_AUDIO_GENRES;

export interface SaveCryptaAudioGenres {
    type: SAVE_CRYPTA_AUDIO_GENRES;
    id: string;
}

export function saveCryptaAudioGenres(id: string): SaveCryptaAudioGenres {
    return {
        type: SAVE_CRYPTA_AUDIO_GENRES,
        id
    };
}

export type CryptaAudioGenresEditorAction =
    | CloseCryptaAudioGenresEditor
    | OpenCryptaAudioGenresEditor
    | ChangeItemCryptaAudioGenres
    | SaveCryptaAudioGenres;
